import React from 'react';
import { FormText, Label as BLabel } from 'reactstrap';
import { FormContext } from './Form';

const Label = ({ required, children, ...props }) => {
  const context = React.useContext(FormContext);
  required = required || (context?.required || []).includes(props.for);

  return (
    <>
      <BLabel {...props}>
        {children}{' '}
        {required ? (
          <FormText inline color='danger' className='font-weight-bold'>
            *
          </FormText>
        ) : null}
      </BLabel>
    </>
  );
};

export default Label;
